const Logo = () => (
    <img
        src="/Spotify_Icon_RGB_White.png"
        alt="image"
        style={{
            height: "1em",
        }}
    />
);

export default Logo;
